<template>
  <div class="d-flex justify-space-around justify-sm-center">
    <div v-if="single" class="result-digit single">
      {{ value }}
    </div>
    <div
      v-else
      class="result-digit"
      v-for="(digit, index) in value"
      :key="index"
    >
      {{ digit }}
    </div>
  </div>
</template>

<script>
import chunk from "lodash/chunk.js";

export default {
  name: "ResultDigitDisplay",
  props: {
    single: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    group: {
      type: Number,
      default: null
    }
  },
  methods: {
    chunk
  },
  computed: {
    computedValue() {
      if (this.group) {
        return chunk(this.value.split(""), this.group);
      } else {
        return this.value;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.result-digit {
	font-family: sans-serif;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	text-shadow: 1px 1px 2px #763d2a;
	padding: 8px;
	font-size: 1.5rem;
	margin: 0 2px;
	font-weight: bold;
	line-height: 20px;
	height: 30px;
	width: 30px;
	border-radius: 50%;
	box-shadow: 1px 1px 6px #938686;
	color: black;

	&.single {
		height: 50px;
		width: 50px;
		font-size: 2.2rem;
	}
}
</style>
